<template>
    <section class="user">
        <div class="title_wrap">
            <span class="title_name">修改基本资料</span>
        </div>
        <div class="userinfo">
            <span class="subtitle">基本信息</span>
            <div class="rowinfo">
                <span class="fadespan">用户名</span>
                <span class="shenspan">{{user.username}}</span>
            </div>
            <div class="rowinfo">
                <span class="fadespan">姓名</span>
                <el-input type="text" class="shenspan" placeholder="请填写姓名"  v-model="user.name" ></el-input>
            </div>
            <div class="rowinfo">
                <span class="fadespan">联络电话</span>
                <el-input disabled placeholder="请填写联络电话" type="text" class="shenspan" v-model="user.phone" ></el-input>
            </div>
            <div class="rowinfo">
                <span class="fadespan">地址</span>
                <el-input disabled placeholder="请填写联络地址" type="text" class="shenspan" v-model="user.addr" ></el-input>
            </div>
            <div class="rowinfo">
                <span class="fadespan">邮箱</span>
                <el-input disabled placeholder="请填写邮箱" type="text" class="shenspan" v-model="user.email" ></el-input>
            </div>
            <div class="rowinfo">
                <span class="fadespan">专业</span>
                <el-input placeholder="请填写专业" type="text" class="shenspan" v-model="user.major" ></el-input>
            </div>
            <div class="rowinfo">
                <span class="fadespan">指导老师</span>
                <el-input placeholder="请填写指导老师" type="text" class="shenspan" v-model="user.teacher" ></el-input>
            </div>
            <div class="rowinfo">
                <span class="fadespan">编号</span>
                <el-input placeholder="请填写你的编号" type="text" class="shenspan" v-model="user.userid" ></el-input>
            </div>
            <div class="rowinfo">
                <span class="fadespan">学校</span>
                <span class="shenspan">{{user.school}}</span>
            </div>
            <div class="rowinfo">
                <span class="fadespan">学校所在省份</span>
                <span class="shenspan">{{user.province}}</span>
            </div>
            <div class="rowinfo">
                <span class="fadespan">个人生活照</span>
                <el-upload
                      class="avatar-up shenspan"
                      :class="{avatarDisabled: avatarIsMax}"
                      :action="url+'/api/upload/json/'"
                      :headers="headers"
                      list-type="picture-card"
                      :limit="1"
                      accept="image/jpeg,image/png,image/jpg"
                      :file-list="avatarList"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-change="handleChange"
                      :on-remove="handleRemove"
                      :on-preview="handlePreview"
                      :before-upload="beforeUpload">
                      <i class="el-icon-plus"></i>
                      <div class="el-upload__text"><i style="font-size:13px">上传个人生活照一张</i><br><i style="font-size:11px">JPG/PNG格式，大小不超过2M<br>不建议为证件照或者艺术照</i></div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogUrl" alt="">
                </el-dialog>
            </div>
            <div class="saveInfo">
                <span @click="saveInfo">保 存</span>
                <span @click="prepage" style="margin-left: 20px;">返 回</span>
            </div>
       </div>
    </section>
</template>
<script>
import axios from 'axios'
import { Loading } from 'element-ui'

export default {
  data () {
    return {
      token: '',
      url: this.API,
      baseUrl: this.API + 'assets/upload/',
      dialogUrl: '',
      dialogVisible: false,
      avatarIsMax: false,
      avatarList: [],
      user: {
        name: '',
        phone: '',
        addr: '',
        teacher: '',
        major: '',
        userid: '',
        avatar_url: '',
        addr: '',
        email: '' 
      }
    }
  },
  computed: {
    headers: function () {
      let _t = this
      return {
        Token: _t.token
      }
    }
  },
  created () {
  },
  mounted () {
    this._getData()
  },
  filters: {
  },
  methods: {
      prepage: function(){
          this.$router.go(-1)
      },
      _getData: function () {
        let _t = this
        _t.token = _t.$ls.get('token')
        axios.post(_t.API + '/api/user/all', {token: _t.token})
          .then(function (resp) {
            if (resp.data.code === '401') {
              _t.$router.push('/login/')
              return
            }
            if (resp.data.code === '0') {
               _t.user = resp.data.user
               if (_t.user.avatar_url != "" && _t.user.avatar_url != undefined) {
                  _t.avatarIsMax = true
                  _t.avatarList.push({name: 'avatar', url: _t.baseUrl + _t.user.avatar_url, file: _t.user.avatar_url})
               }
            } else {
               _t.$messagewarning(resp.data.msg)
            }
             
          })
          .catch(function (error) {
            console.log(error)
          })
    },
    saveInfo: function(){
        let _t = this
        _t.token = _t.$ls.get("token")
        let ld = Loading.service({'fullscreen':true,'text':'保存中，请稍后'})
        
        if(_t.user.name==''||_t.user.phone=='' || _t.user.addr == '' || _t.user.email == ''){
            _t.$messagewarning("请填写完整信息")
            ld.close()
            return
        }
        if(_t.user.teacher ==''){
            _t.$messagewarning("请填写指导老师")
            ld.close()
            return
        }
        if(_t.user.major ==''){
            _t.$messagewarning("请填写专业")
            ld.close()
            return
        }
        if(_t.user.userid ==''){
            _t.$messagewarning("请填写编号")
            ld.close()
            return
            
        }
        if(_t.user.avatar_url ==''){
            _t.$messagewarning("请上传个人生活照")
            ld.close()
            return
        }
        let user = {
            token: _t.token,
            name: _t.user.name,
            phone: _t.user.phone,
            addr: _t.user.addr,
            teacher: _t.user.teacher,
            major: _t.user.major,
            userid: _t.user.userid,
            avatar_url: _t.user.avatar_url,
            addr: _t.user.addr,
            email: _t.user.email
        }
        axios.post("/api/user/updateInfo", user)
        .then(function(resp){
            if (resp.data.code === '0') {
              _t.$messagesuccess(resp.data.msg)
              _t.$router.push('/user')
            } else {
              _t.$messagewarning(resp.data.msg)
            }
            ld.close()
        })
        .catch(function(error){
            console.log(error)
            ld.close()
        })
    },
    handleRemove: function (file, fileList) {
      let _t = this
      _t.user.avatarUrl = ''
      _t.avatarList = []
      _t.avatarIsMax = false
      return
    },
    handlePreview: function (file) {
      this.dialogUrl = file.url
      this.dialogVisible = true
    },
    handleError (err, file, fileList) {
      console.log(err)
    },
    handleChange (file, fileList) {
      let _t = this
      if (fileList.length >= 1) {
        _t.avatarIsMax = true
      } else {
        _t.avatarIsMax = false
      }
      return
    },
    handleSuccess (res, file) {
      let _t = this
      _t.fullscreenLoading = false
      if (res.code === '401') {
        _t.$messagewarning('登录验证已失效，请重新登录')
        _t.$router.push('/login/')
        return
      }
      if (res.error === 1) {
        _t.$messageerror(res.message)
        return
      } else {
        _t.user.avatar_url = res.file
        _t.avatarList.push({file: res.file, url: _t.baseUrl + res.file})
        _t.avatarIsMax = true
        return
      }
    },
    beforeUpload (file) {
      let _t = this
      let regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/
      const isLtSize = file.size / 1024 / 1024 < 2

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件')
        _t.avatarIsMax = false
        return false
      }
      if (!isLtSize) {
        this.$messagewarning('上传图片大小不能超过2M!')
        _t.avatarIsMax = false
        return false
      }
    },
  }
}
    
</script>
<style lang='stylus'>
@import '~@/common/stylus/index'

.clearfix:after{
  content:"";
  display: table;
  clear:both;
}
.clearfix{
  *zoom: 1;
}
.title_wrap{
    border-bottom: 1px solid #a3a3a3;
    margin-bottom: 25px;
    margin-top: 65px;
    text-align: left;
    position: relative;
}
.title_name{
    font-family: sy;
    border-bottom: 4px solid $color-dark-blue;
    color: black;
    font-weight:600;
    font-size: 20px;
}
.subtitle{
    width: 90px;
    text-align: right;
    font-size: 16px;
    padding-bottom:10px;
}
.userinfo{
    margin: 40px auto 0;
    position: relative;
}
.bottom{
    margin-top:20px;
}
.shenspan{
    font-family: sylight;
    font-size: 16px;
    display: inline-block;
    color:black;
    text-align:left;
    margin-left: 15px;
    width: 80%;
}
.fadespan{
    font-family: sylight;
    font-size: 16px;
    display: inline-block;
    text-align: right;
    color:gray;
    width:120px;
}
.most{
    font-family: sylight;
    font-size: 16px;
    display: inline-block;
    color:black;
    text-align: left;
    margin-left: 15px;
}
.different{
    vertical-align: top;
}
.changemail{
    margin-top: 30px;
}
.changeinfo{
    margin-top: 200px;
}
.changepwd{
    margin-top: 60px;
}
.disabled el-input{
    background: gray;
}

.rowinfo{
    display: block;
    margin-bottom: 10px;
    margin-top: 20px;
}
.subtitle_wrap{
  border-bottom: 1px solid #f2f6fa;
}
.saveInfo>el-input{
    width: 150px;
    height: 40px;
    background: #f7b52d;
    border-radius: 2px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: sy;
}
.saveInfo>el-input.prepage{
    background:none;
    border: 1px solid gray;
    border-radius: 2px;
    color: gray;
}
.saveInfo{
    text-align: center;
    margin-top: 50px;
    margin-bottom: 50px;
}
.saveInfo span {
    border-radius: 2px;
    background: $color-dark-blue;
    height: 40px !important;
    line-height: 40px;
    color: white;
    font-family: sy;
    width: 300px;
    cursor: pointer;
    font-size: 16px;
}
section.user{
    width:900px;
    margin:0 auto;
}
.el-input__inner{
    background-color: #eee;
}

el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #25335e;
    outline: 0;
}
.avatarDisabled .el-upload--picture-card {
    display: none !important;
}
.avatar-up .el-upload-list--picture-card {
    margin: 0;
    display: inline;
    vertical-align: top;
}
.avatar-up .el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 300px;
    height: 225px;
    line-height: 1.5;
    margin: 0 8px 8px 0;
    display: inline-block;
}
.avatar-up .el-upload {
    display: inline-block;
    text-align: center;
    outline: none;

}
.avatar-up .el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 300px !important;
    height: 225px !important;
    line-height: 1.5;
    cursor: pointer;
    vertical-align: top;
    display: inline-block;
}
.avatar-up .el-upload--picture {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 300px;
    height: 225px;
    line-height: 1.5;
    cursor: pointer;
    vertical-align: top;
    display: inline-block;
}
.avatar-up .el-icon-plus {
    font-size: 28px;
    color: #fff !important;
    border-radius: 50%;
    background-color: $color-dark-blue;
    position: relative;
    top: 80px;
}
.avatar-up .el-upload__text {
    position: relative;
    top: 100px;
    color: #a3a3a3;
}

</style>



// WEBPACK FOOTER //
// ChangeInfo.vue?37c1f1fe